import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";
import { FiLifeBuoy } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const ImmigrationSupport = () => {
    const { t } = useTranslation();
    const description = t("service_pages.immigration_support.description");
    const features = t("service_pages.immigration_support.features", { returnObjects: true });
    const highlights = t("service_pages.immigration_support.highlights", { returnObjects: true });
    const steps = t("service_pages.immigration_support.steps", { returnObjects: true });
    const faqs = t("service_pages.immigration_support.faqs", { returnObjects: true });

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Immigration Support Services",
        description,
        provider: {
            "@type": "LocalBusiness",
            name: "Citizen Hub Immigration Services",
            telephone: "+1 3108802133",
            email: "info@citznhub.com",
        },
        areaServed: [
            "United States",
            "California",
            "New York",
            "Texas",
            "Florida",
        ],
    };

    // Create a simple icon-based image placeholder
    const IconPlaceholder = () => (
        <div className="w-full h-96 lg:h-[28rem] bg-gradient-to-br from-teal-500 to-blue-600 rounded-2xl shadow-lg flex items-center justify-center">
            <FiLifeBuoy className="w-48 h-48 text-white opacity-80" />
        </div>
    );

    return (
        <ServiceDetailLayout
            title={t("service_pages.immigration_support.title")}
            subtitle={t("service_pages.immigration_support.subtitle")}
            description={description}
            features={features}
            highlights={highlights}
            steps={steps}
            faqs={faqs}
            imageSrc={null}
            imageAlt="Immigration support services"
            canonicalUrl="https://citizenhubimmigration.com/services/immigration-support"
            structuredData={structuredData}
            customImage={<IconPlaceholder />}
        />
    );
};

export default ImmigrationSupport;
